// extracted by mini-css-extract-plugin
export default {"dtg-layout-without-sidebar":"dtg-layout-without-sidebar_ysy0y"};